
















import InputField from "./InputField";
import Multiselect from "vue-multiselect";
import { Config } from "../../utils/Config";
import { multiply } from "lodash";

export default {
    name: "OptionSelect",
    components: { InputField, Multiselect },
    props: {
        label: String,
        value: [Number, String, Array],
        multiple: Boolean,
        options: Object,
        allowEmpty: Boolean,
    },
    data() {
        return {
            selected: null,
            optionsArray: [],
            vueMultiselectParams: Config.vueMultiselectParams,
        };
    },
    created() {},
    watch: {
        selected: function () {
            if (this.multiple) {
                this.$emit("input", this.selected);
            } else {
                if (this.selected) {
                    this.$emit("input", this.selected.id);
                } else if (this.allowEmpty) {
                    this.$emit("input", null);
                }
            }
        },
        options: {
            immediate: true,
            handler: function () {
                this.optionsArray = _.toArray(this.options);
                this.selected = _.find(this.optionsArray, { id: this.value });
            },
        },
        value: {
            immediate: true,
            handler: function () {
                if (this.multiple) {
                    this.selected = this.value;
                } else {
                    this.selected = _.find(this.optionsArray, {
                        id: this.value,
                    });
                }
            },
        },
    },
};
